<template>
  <div>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="10" lg="9">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="reset"
                @keydown="form.onKeydown($event)"
            >
                <v-container grid-list-xl>
                    <v-toolbar dark>
                        <v-toolbar-title> {{ title }} </v-toolbar-title>
                        <v-spacer />
                    </v-toolbar>
                    <v-stepper v-model="next">
                        <v-stepper-header>
                            <v-stepper-step
                            :complete="next > 1"
                            step="1"
                            >
                            Rol
                            </v-stepper-step>

                            <v-divider />

                            <v-stepper-step
                            :complete="next > 2"
                            step="2"
                            >
                            Permisos
                            </v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-layout class="wrap justify-space-around form-body">
                                    <v-col
                                    cols="12"
                                    >
                                        <v-text-field
                                            v-model.trim="form.name"
                                            :rules="[rules.required]"
                                            :maxlength="100"
                                            label="Nombre"
                                            placeholder="Super administrador"
                                            required
                                        />
                                    </v-col>
                                    <v-col
                                    cols="12"
                                    >
                                        <v-select
                                            v-model="form.type"
                                            :items="items_types"
                                            :rules="[rules.required]"
                                            label="Tipo de Rol"
                                        />
                                    </v-col>
                                    <v-btn color="success" @click="validarRol()">
                                    Siguiente
                                    </v-btn>
                                </v-layout>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-layout class="wrap justify-space-around form-body">
                                    <v-row class="custom-good-table" align="center" justify="space-around" style="width: 100%">
                                        <v-col cols="12">
                                            <vue-good-table
                                                ref="Permisos"
                                                :columns="columns"
                                                :rows="rows"
                                                :group-options="{
                                                    enabled: true,
                                                    collapsable: true
                                                }"
                                                :select-options="{
                                                    enabled: true,
                                                    selectionText: 'Permisos seleccionados',
                                                    clearSelectionText: 'Limpiar',
                                                    selectAllByGroup: true,
                                                }"
                                                @on-selected-rows-change="selectionChanged"
                                            >
                                            </vue-good-table>
                                        </v-col>
                                    </v-row>
                                    <v-row align="center" justify="space-around">
                                        <v-btn :color="themeColor" @click="next = 1">
                                            regresar
                                        </v-btn>
                                        <v-btn color="success" @click="save">
                                            Guardar
                                        </v-btn>
                                        <v-btn color="red" @click="cancel">
                                            Cancelar
                                        </v-btn>
                                    </v-row>
                                </v-layout>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-container>
            </v-form>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from 'vform';
import { VueGoodTable } from 'vue-good-table';

export default {
    metaInfo() {
        return { title: this.$t('roles') };
    },
    props: {
      roleId: { default: '' },
    },
    components: {
        VueGoodTable,
    },
    data: () => ({
      form: new Form({
        name: '',
        role: 1,
        busy: false,
        active: false,
        itemsPermission: [],
        type: '',
      }),
      columns: [
        {
          label: 'Permiso',
          field: 'name',
        },
      ],
      rows: [],
      allPermissions: false,
      items: [],
      items_types: [
        { value: 'A', text: 'ROL DE ADMINISTRADOR' },
        { value: 'D', text: 'ROL DE DISTRIBUIDOR' },
        { value: 'C', text: 'ROL DE CLIENTE ID' },
      ],
      next: 1,
      title: 'Nuevo rol de sistema',
      rules: {
        required: (v) => !!v || 'El campo es requerido',
      },
      method: 'POST',
      apiURL: '/api/maintenance/roles/store',
    }),
    computed: {
      ref() { return this.form.id; },
      ...mapGetters({
        themeColor: 'theme/themeColor',
      }),
    },
    async mounted() {
      if (this.roleId) {
        window.axios.get(`/api/maintenance/roles/${this.roleId}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          const permissions = result.data.permissions.map((permission) => (permission.id));
          this.form.itemsPermission = permissions;
          this.disabled = true;
          this.apiURL = `/api/maintenance/roles/${this.roleId}/update`;
          this.method = 'PUT';
          this.title = 'Editar rol del sistema';
          this.message = `Se ha editado el rol ${result.data.name} exitosamente.`;
        });
      }
    },
    methods: {
        selectionChanged(params) {
            const permissions = params.selectedRows.map((item) => item.id);
            this.form.itemsPermission = permissions;
        },
        cancel() {
            this.$router.go(-1); // someValue
        },
        validarRol() {
            if (this.$refs.form.validate() && this.form.role_name !== '') {
                const url = '/api/maintenance/permissions?currentPage=1&perPage=200';
                window.axios.get(url)
                .then((response) => {
                    const categorias = [];
                    this.items = response.data.items;
                    this.items.forEach((item) => {
                        if (!categorias.includes(item.description_category)) {
                            categorias.push(item.description_category);
                        }
                    });
                    categorias.forEach((categoria) => {
                        const row = { name: categoria, children: [] };
                        this.items.forEach((item) => {
                            if (categoria === item.description_category) {
                                row.children.push({ id: item.id, name: item.description });
                            }
                        });
                        this.rows.push(row);
                    });
                    this.next = 2;
                    if (this.roleId) {
                        this.rows.forEach((item, index) => {
                            const children = item.children.map((child) => child.id);
                            this.form.itemsPermission.forEach((itemPermission) => {
                                if (children.includes(itemPermission)) {
                                    const index2 = children.indexOf(itemPermission);
                                    this.$set(this.rows[index].children[index2], 'vgtSelected', true);
                                }
                            });
                        });
                    }
                });
            }
        },
        save() {
            this.validate();
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.form.busy = true;
                this.store();
            }
        },
        store() {
            if (this.form.itemsPermission.length > 0) {
                window.axios({
                    method: this.method,
                    url: this.apiURL,
                    data: this.form,
                }).then((result) => {
                    this.$router.push({ name: 'maintenance.roles', params: { action: 'created', message: result.data.message } });
                }).catch(() => {
                    this.form.busy = false;
                });
            } else {
                // eslint-disable-next-line
                console.log(this.form);
            }
        },
    },
};
</script>
<style scoped>
    .custom-good-table {
        width: 100%;
    }
</style>
